module.exports = __webpack_public_path__ + "img/blue_banyan.5986b1ca.jpg";